
import { all } from 'redux-saga/effects';
//import { createHashHistory as createHistory } from 'history';

import { authFlow } from '../common/client/sagas/auth';

import { serverApi } from '../core';
import { sagas as dataSagas } from '../data';
import { sagas as mapSagas } from '../map';
import { sagas as measurementSagas } from '../measurement';
import { sagas as printSagas } from '../print';
import { sagas as projectSagas } from '../project';
import { sagas as searchSagas } from '../search';
import { sagas as shareSagas } from '../share';

export const SET_PROJECT_ID = 'app/SET_PROJECT_ID';
export const SET_UI_VALUE = 'app/SET_UI_VALUE';

export default function getActions(dispatch) {
    return {
        setProjectId: (projectId) => dispatch({
            type: SET_PROJECT_ID, projectId
        }),
        setUiValue: (name, value) => dispatch({
            type: SET_UI_VALUE, name, value
        })
    };
}

//let history = createHistory();

export function* rootSagas(anonymous) {
    const options = {
        history: history,
        serverApi: serverApi
    };
    yield all([
        dataSagas.watchGetDataModelDefinition(options),
        dataSagas.watchDeleteObject(options),
        dataSagas.watchFetchObjects(options),
        dataSagas.watchInsertObject(options),
        dataSagas.watchUpdateObject(options),
        dataSagas.watchUpdateAttributeForObjects(options),
        dataSagas.watchDeleteDocument(options),
        dataSagas.watchGetDocument(options),
        dataSagas.watchInsertDocument(options),
        dataSagas.watchInsertDocumentToObjects(options),
        dataSagas.watchUpdateDocument(options),

        mapSagas.watchChangeLayerVisibility(options),
        mapSagas.watchChangeView(options),

        projectSagas.watchGetProject(options),
        projectSagas.watchSetProject(options),

        printSagas.watchGetDefinition(options),
        printSagas.watchGenerateReport(options),

        searchSagas.watchClearSearchResult(options),
        searchSagas.watchDoSearch(options),
        searchSagas.watchGetDefinition(options),
        searchSagas.watchSelectQuery(options),

        authFlow({
            anonymous: anonymous,
            history: history,
            afterLogoutUrl: '/',
            serverApi: serverApi
        })
    ]);
}
